var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreyEnvelope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 19,
    viewBox: "0 0 26 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2977 9.59045C11.7854 9.96499 12.3832 10.1679 12.9979 10.1679C13.6127 10.1679 14.2105 9.965 14.6982 9.59045L25.4882 1.1829V1.18311C24.9683 0.44147 24.1196 0 23.214 0H2.78546C1.82436 0.00207268 0.932665 0.500766 0.427734 1.31868L11.2977 9.59045Z",
    fill: "#C4C7D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8361 11.0624C15.0238 11.6863 14.0281 12.0243 13.004 12.0243C11.9796 12.0243 10.9842 11.6863 10.1718 11.0624L0 3.32764V15.7864C0 16.5253 0.293492 17.2338 0.815816 17.7563C1.33835 18.2786 2.04678 18.5721 2.78571 18.5721H23.2143C23.9532 18.5721 24.6616 18.2786 25.1842 17.7563C25.7065 17.2338 26 16.5253 26 15.7864V3.14404L15.8361 11.0624Z",
    fill: "#C4C7D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyEnvelope);
export default __webpack_public_path__ + "static/media/greyEnvelope.88c85772a1fb4e74d2483da33eb83e81.svg";
export { ForwardRef as ReactComponent };